import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#ru_svg__clip0_20_177)\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"white\"></rect><rect x=\"0.5\" y=\"1.5\" width=\"19\" height=\"17\" rx=\"3.5\" stroke=\"black\" stroke-opacity=\"0.1\"></rect><rect y=\"13\" width=\"20\" height=\"6\" fill=\"#E84040\"></rect><rect y=\"7\" width=\"20\" height=\"6\" fill=\"#4084E8\"></rect></g><defs><clipPath id=\"ru_svg__clip0_20_177\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }